// extracted by mini-css-extract-plugin
export var contentContainer = "FeaturedInModule-module--contentContainer--f0c17";
export var divider = "FeaturedInModule-module--divider--ba31e";
export var itemContainer = "FeaturedInModule-module--itemContainer--2de43";
export var itemsContainer = "FeaturedInModule-module--itemsContainer--a1bfd";
export var link = "FeaturedInModule-module--link--e0b0e";
export var logoContainer = "FeaturedInModule-module--logoContainer--5ce82";
export var quote = "FeaturedInModule-module--quote--2904d";
export var scrollingWrapper = "FeaturedInModule-module--scrollingWrapper--633f5";
export var title = "FeaturedInModule-module--title--b5986";
export var titleContainer = "FeaturedInModule-module--titleContainer--9b199";